/* eslint-disable @typescript-eslint/no-magic-numbers */
import type { SigningFeatureConfig } from './type';

export const signing: Partial<SigningFeatureConfig> = {
    isVisibleExplanationOnConfirmation: true,
    otpLengths: [6],
};
